import React from "react"
import '../../css/style.css'

import Header from "../components/header"
import Footer from "../components/footer"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck , faDollarSign,  } from '@fortawesome/free-solid-svg-icons'
import { faThumbsUp , faSmileWink } from '@fortawesome/free-regular-svg-icons'


export default function Contact() {
  return (
    <div id="page">
      <Footer />

      <Header />
      <div id="page-wrapper">
        <div className="container">
          <div className = "col-md-12">
            <h1>Welcome to FixStars</h1>
            <h3>What is different between FixStars and other shops?</h3>
            <div className ="row">
              <div className = "col-md-3">
                <div className = "about-item">
                  <div className ="about-item-icon">
                    <FontAwesomeIcon icon = {faThumbsUp} />
                  </div>
                  <h4>Repair Specialist</h4>
                  <p>FixStars' Technician are Specialist. We repair meticulously and perfectly. Trust us!</p>
                </div>                    
              </div>

              <div className = "col-md-3">
                <div className = "about-item">
                  <div className ="about-item-icon">
                    <FontAwesomeIcon icon = {faCheck} />
                  </div>
                  <h4>High Quality Parts</h4>
                  <p>Don't compare other store's general quality. We use high quality parts! Come to meet our qualified parts now!</p>
                </div>                    
              </div>

              <div className = "col-md-3">
                <div className = "about-item">
                  <div className ="about-item-icon">
                    <FontAwesomeIcon icon = {faDollarSign} />
                  </div>
                  <h4>Reasonable Price</h4>
                  <p>Our price is reasonable! Quality is high but Price is low.</p>
                </div>                    
              </div>

              <div className = "col-md-3">
                <div className = "about-item">
                  <div className ="about-item-icon">
                    <FontAwesomeIcon icon = {faSmileWink} />
                  </div>
                  <h4>Satisfactory service</h4>
                  <p>We are always happy to serve you. Don't hesitate to ask something Anytime!</p>
                </div>                    
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) 
}